var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaretLt({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "7px",
    height: "11px",
    viewBox: "0 0 7 11",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CaretSolid-Lt",
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "right-chevron",
    transform: "translate(3.500000, 5.500000) scale(1, -1) translate(-3.500000, -5.500000) ",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.73607752,4.86453336 L2.08876001,0.268262525 C1.91761361,0.0893961126 1.70389908,0 1.44719196,0 C1.19048485,0 0.976770313,0.0894950294 0.805623916,0.268262525 L0.263897508,0.797863396 C0.0880324138,0.972031258 9.98666067e-05,1.18373807 9.98666067e-05,1.43320639 C9.98666067e-05,1.67795143 0.0880074471,1.89218062 0.263897508,2.07569613 L3.72809533,5.50002473 L0.263747708,8.93140116 C0.0879325472,9.10556902 0,9.31727583 0,9.56676888 C0,9.81148919 0.0879075805,10.0257926 0.263747708,10.2092339 L0.805524049,10.7387606 C0.981364177,10.9129284 1.19530342,11 1.4470921,11 C1.69898065,11 1.91286995,10.9129284 2.08866015,10.7387606 L6.73607752,6.14248974 C6.91199255,5.95892477 7,5.74474504 7,5.5 C7,5.25053168 6.91199255,5.03870122 6.73607752,4.86453336 Z",
    id: "Path"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretLt);
export default __webpack_public_path__ + "static/media/Caret Lt.136e9e04950637db9097eb3fd05315cf.svg";
export { ForwardRef as ReactComponent };